import FJVideoSettingsContainer from '../FJVideoSettings/FJVideoSettingsContainer';
import PropTypes from 'prop-types';
import FJConstant from '../../../constants/FJConstant';
import FJPptToVideoStartContainer from '../FJPptToVideoStart/FJPptToVideoStartContainer';
import FJDisplayPanel from '../FJDisplayPanel/FJDisplayPanel';
const FJPptToVideo = props => {
    const { textToVideoStep } = props;
    return (
        <>
            <FJDisplayPanel active={textToVideoStep === FJConstant.STEP_TYPE_HOME}>
                <FJPptToVideoStartContainer />
            </FJDisplayPanel>
            <FJDisplayPanel active={textToVideoStep === FJConstant.STEP_TYPE_VIDEO_SETTINGS}>
                <FJVideoSettingsContainer />
            </FJDisplayPanel>
        </>
    );
};

FJPptToVideo.propTypes = {
    textToVideoStep: PropTypes.string,
};

export default FJPptToVideo;
